import { fileTypeFromBlob } from "file-type/core";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
class FileType {
    fileTypeFromBlob(blob) {
        return _async_to_generator(function*() {
            let mime = blob.type;
            try {
                const result = yield fileTypeFromBlob(blob);
                if (null == result ? void 0 : result.mime) mime = result.mime;
            } catch (e) {
                this.logger.error(e, {
                    tags: {
                        vkdoc_error_type: 'mime-type'
                    },
                    context: {
                        error: e
                    }
                });
            }
            return mime;
        }).call(this);
    }
    constructor(logger){
        this.logger = logger;
    }
}
export { FileType };
